import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faHouse,
  faHospital,
  faRightFromBracket,
  faClock,
  faCircleInfo,
  faMoneyBills,
  faCircleExclamation,
  faBank,
  faPlus,
  faFile,
  faClipboard,
} from "@fortawesome/free-solid-svg-icons";
import logoMedici from "../../assets/logoMedici.png";
import { useNavigate } from "react-router";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import { useTheme } from "./ThemeContext";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Input from "@mui/joy/Input";
import Button from "@mui/joy/Button";
import MailIcon from "@mui/icons-material/Mail";
import inviteMemberLogo from "../../assets/inviteMember.png";
import { useData } from "./MemberData";
import axios from "axios";

const Sidebar = ({
  setCurrentPage,
}: {
  setCurrentPage: (page: string) => void;
}) => {
  const navigate = useNavigate();
  const { getDiscordMemberInfo } = useData();
  const [isExpanded, setIsExpanded] = useState(false);
  const [myDiscordID, setMyDiscordID] = useState("");

  useEffect(() => {
    setMyDiscordID(Cookies.get("myDiscordID") || "");
  }, [myDiscordID]);

  const toggleSidebar = () => {
    setIsExpanded((prev) => !prev);
  };

  const menuItems = [
    { icon: faHouse, label: "Acasa", page: "home" },
    { icon: faHospital, label: "Membrii", page: "members" },
    { icon: faClock, label: "Activitate", page: "activity" },
    { icon: faCircleInfo, label: "INFO Utile", page: "info" },
    { icon: faMoneyBills, label: "Bonusuri", page: "bonus" },
    { icon: faCircleExclamation, label: "Sanctiuni", page: "punishmentsList" },
    { icon: faClipboard, label: "Teste Departament", page: "test" },
  ];

  async function logOutUser() {
    try {
      await axios.post("http://panelmedici.fplayt.ro:5000/api/logout", {
        refreshToken: Cookies.get("accessToken"),
      })
      Cookies.remove("accountCreated");
      navigate("/");
    } catch (err) {
      toast.error("A aparut o eroare! Nu ai fost delogat.")
      console.log(err);
    }
  }
  const { theme } = useTheme();
  const [open, setOpen] = useState(false);
  const [sendToMail, setToMail] = useState(null);

  const handleClose = () => {
    setOpen(false);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "27%",
    height: "40%",
    display: "flex",
    flexDirection: "column",
    gap: "2%",
    bgcolor: theme === "dark" ? "#202020" : "rgba(255,255,255)",
    boxShadow: "0 0px 20px rgba(255,255,255,0.3)", // Orange box shadow
    borderRadius: ".5vw",
    outline: "none",
    p: 4,
  };

  const rand = function () {
    return Math.random().toString(36).substr(2);
  };

  const token = function () {
    return rand() + rand();
  };

  function handleChangeMail(e: any) {
    setToMail(e.target.value);
  }

  function isValidEmail(email: any) {
    const gmailOrYahooRegex = /@(gmail|yahoo)\.com$/i;
    const atSymbolRegex = /@/;
    return gmailOrYahooRegex.test(email) && atSymbolRegex.test(email);
  }
  
  const sendEmail = async () => {
    const email = sendToMail;
    const userToken = token();
    if (isValidEmail(email)) {
      try {
        let bToken = Cookies.get("accessToken");
        await axios.post("http://panelmedici.fplayt.ro:5000/api/create-token", { token: userToken, email: email }, { headers: { Authorization: `Bearer ${bToken}` } });
        toast.success("Token creat cu succes!");
      } catch (error) {
        toast.error("A aparut o eroare! Token-ul nu a fost creat.");
        return;
      }
    } else {
      toast.error("Email invalid!");
    }
  };

  return (
    <div
      className={`${
        isExpanded ? "w-[15%]" : "w-[8%]"
      } h-full flex flex-col items-center justify-between transition-all duration-300`}
    >
      <div className="w-full h-[10%] flex items-center justify-center">
        <img
          src={logoMedici}
          alt="Logo Medici"
          className={`mt-[10%] ${
            isExpanded ? "w-[50%]" : "w-[60%]"
          } transition-all duration-300`}
        />
      </div>

      <div className="w-full h-[75%] flex flex-col items-center gap-[1%]">
        <div
          onClick={toggleSidebar}
          className={`${
            isExpanded
              ? "w-[90%] h-[3.1vw] px-[8%]"
              : "w-[3.1vw] h-[3.1vw] flex items-center justify-center"
          } min-h-[3.1vw] flex items-center bg-white rounded-full cursor-pointer gap-[4%] py-[5%]`}
        >
          <FontAwesomeIcon
            className="text-[#323232] text-[1vw] ml-[-2%]"
            icon={faBars}
          />
          {isExpanded && (
            <span className="text-[#323232] text-[1vw] h-full textSemiBold flex items-center">
              Ascunde Meniu
            </span>
          )}
        </div>

        {menuItems.map(({ icon, label, page }, index) => (
          <div
            key={index}
            onClick={() => setCurrentPage(page)}
            className={`${
              isExpanded
                ? "w-[90%] h-[3.1vw] px-[8%]"
                : "w-[3.1vw] h-[3.1vw] flex items-center justify-center"
            } min-h-[3.1vw] flex items-center bg-white rounded-full cursor-pointer gap-[4%] py-[5%]`}
          >
            <FontAwesomeIcon
              className="text-[#323232] text-[1vw] ml-[-2%]"
              icon={icon}
            />
            {isExpanded && (
              <span className="text-[#323232] text-[1vw] h-full textSemiBold flex items-center">
                {label}
              </span>
            )}
          </div>
        ))}
        {getDiscordMemberInfo(myDiscordID, "callsign") < 300 && (
          <div
            onClick={() => setCurrentPage("cvs")}
            className={`${
              isExpanded
                ? "w-[90%] h-[3.1vw] px-[8%]"
                : "w-[3.1vw] h-[3.1vw] flex items-center justify-center"
            } min-h-[3.1vw] flex items-center bg-white rounded-full cursor-pointer gap-[4%] py-[5%]`}
          >
            <FontAwesomeIcon
              className="text-[#323232] text-[1vw] ml-[-2%]"
              icon={faFile}
            />
            {isExpanded && (
              <span className="text-[#323232] text-[1vw] h-full textSemiBold flex items-center">
                Aplicatii
              </span>
            )}
          </div>
        )}
        {getDiscordMemberInfo(myDiscordID, "callsign") < 100 && (
          <div
            onClick={() => setCurrentPage("treasury")}
            className={`${
              isExpanded
                ? "w-[90%] h-[3.1vw] px-[8%]"
                : "w-[3.1vw] h-[3.1vw] flex items-center justify-center"
            } min-h-[3.1vw] flex items-center bg-white rounded-full cursor-pointer gap-[4%] py-[5%]`}
          >
            <FontAwesomeIcon
              className="text-[#323232] text-[1vw] ml-[-2%]"
              icon={faBank}
            />
            {isExpanded && (
              <span className="text-[#323232] text-[1vw] h-full textSemiBold flex items-center">
                Visterie
              </span>
            )}
          </div>
        )}
        {getDiscordMemberInfo(myDiscordID, "callsign") < 300 && (
          <div
            onClick={() => setOpen(true)}
            className={`${
              isExpanded
                ? "w-[90%] h-[3.1vw] px-[8%]"
                : "w-[3.1vw] h-[3.1vw] flex items-center justify-center"
            } min-h-[3.1vw] flex items-center bg-white rounded-full cursor-pointer gap-[4%] py-[5%]`}
          >
            <FontAwesomeIcon
              className="text-[#323232] text-[1vw] ml-[-2%]"
              icon={faPlus}
            />
            {isExpanded && (
              <span className="text-[#323232] text-[1vw] h-full textSemiBold flex items-center">
                Invita Membru
              </span>
            )}
          </div>
        )}
      </div>

      <div className="w-full flex items-center justify-center">
        <div
          onClick={logOutUser}
          className={`${
            isExpanded
              ? "w-[90%] h-[3.1vw] px-[8%]"
              : "w-[3.1vw] h-[3.1vw] flex items-center justify-center"
          } min-h-[3.1vw] flex items-center bg-white rounded-full cursor-pointer gap-[4%] py-[5%]`}
        >
          <FontAwesomeIcon
            className="text-[#323232] text-[1vw] ml-[-2%]"
            icon={faRightFromBracket}
          />
          {isExpanded && (
            <span className="text-[#323232] text-[1vw] h-full textSemiBold flex items-center">
              Deconecteaza-te
            </span>
          )}
        </div>
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style} className="flex flex-col items-center">
            <span className="text-black dark:text-white textSemiBold text-[1.2vw] w-full text-center">
              Invita membru in departament
            </span>
            <img
              className="w-[40%] mt-[1%] mb-[1%]"
              src={inviteMemberLogo}
              alt=""
            />
            <form
              action="submit"
              className="w-full h-[30%] flex flex-col items-center"
            >
              <div className="w-full h-full flex items-center justify-center">
                <Input
                  onChange={handleChangeMail}
                  startDecorator={<MailIcon />}
                  endDecorator={
                    <Button
                      onClick={sendEmail}
                      sx={{
                        backgroundColor: "#D8630F",
                        color: "white",
                        "&:hover": {
                          backgroundColor: "darkorange",
                        },
                      }}
                    >
                      Invita
                    </Button>
                  }
                  placeholder="Introdu email"
                  sx={{
                    "--Input-radius": "25px",
                    "--Input-gap": "10px",
                    "--Input-placeholderOpacity": 1,
                    "--Input-focusedThickness": "2px",
                    "--Input-minHeight": "50px",
                    "--Input-decoratorChildHeight": "38px",
                    "--Input-paddingInline": "10px",
                    backgroundColor: "#323232",
                    color: "grey",
                    borderColor: "transparent",
                    borderWidth: "2px",
                    outline: "none",
                    width: "65%",
                    height: "40%",
                    "&:hover": { borderColor: "#D8630F" },
                    "&:focus": { borderColor: "#D8630F" },
                    "&::placeholder": {
                      color: "grey",
                    },
                  }}
                />
              </div>
            </form>
          </Box>
        </Fade>
      </Modal>
      <ToastContainer />
    </div>
  );
};

export default Sidebar;
